import { OrderStatus } from './OrderStatus'

export const WizardSteps = {
  [OrderStatus.open]: 2,
  [OrderStatus.pending]: 2,
  [OrderStatus.userActionRequired]: 2,
  [OrderStatus.validated]: 2,
  [OrderStatus.autocomplete]: 2,
  [OrderStatus.autocompletionFailed]: 3,
  [OrderStatus.validationError]: 2,
  [OrderStatus.paymentOpen]: 3,
  [OrderStatus.paymentPending]: 3,
  [OrderStatus.paymentRefused]: 3,
  [OrderStatus.paid]: 4,
  [OrderStatus.inProduction]: 4,
  [OrderStatus.finished]: 4,
  [OrderStatus.error]: 2,
  [OrderStatus.cancelled]: 99,
  getKey
}
// get the enum key by value
function getKey(enumValue) {
  return Object.keys(OrderStatus).find(key => OrderStatus[key] === enumValue)
}
